/* script */
//
//
//

const __vue_script__ = {
    name: 'DiffViewer',

    props: {
        diff: {
            type: Object,
            required: true
        },

        eventId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            htmlDiff: null,
            worker: null
        };
    },

    mounted() {
        this.initWorker();
        this.computeDiff();
    },

    beforeDestroy() {
        this.terminate();
    },

    methods: {
        initWorker() {
            try {
                console.info('[DiffViewer] Initializing the worker');

                /** @type {WorkerOptions} */
                const workerOptions = {
                    name: 'spotme-diff-generator',
                    credentials: 'include'
                };

                this.worker = new Worker(`${window.BSTG.extLibs}/diff-generator${window.BSTG.scriptSuffix}`, workerOptions);
                this.worker.onerror = event => console.error('[DiffViewer] Could not initialize the worker.', event);
                this.worker.onmessage = this.handleWorkerMessage.bind(this);
            } catch (error) {
                console.error('[DiffViewer] Workers not supported, can\'t proceed further');
            }
        },

        async computeDiff() {
            try {
                const { id, source: revA, target: revB } = this.diff;
                const source = await this.$services.appScripts.callAppScript(this.eventId, 'dev-tools/get-doc', { id, rev: revA });
                const target = await this.$services.appScripts.callAppScript(this.eventId, 'dev-tools/get-doc', { id, rev: revB });

                this.worker.postMessage({
                    command: 'generate',
                    source, target,
                    eventId: this.eventId,
                    options: {
                        drawFileList: false
                    }
                });

            } catch (error) {
                console.error('[DiffViewer] Could not load one or both revisions', error.message);
            }
        },

        /**
         * @param {MessageEvent} event
         */
        handleWorkerMessage(event) {
            const response = event.data;
            if (response.type === 'diff') {
                this.htmlDiff = response[response.type];
            }
        },

        terminate() {
            console.info('[DiffViewer] Terminating the worker');
            this.worker.postMessage({ command: 'kill' });
            this.worker.terminate();
            this.worker = null;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"diff-viewer",domProps:{"innerHTML":_vm._s(_vm.htmlDiff)}})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DiffViewer.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__